import appointmentSaga from "./Screens/ScheduleAppointment/sagas"
export default [appointmentSaga]